import { render } from "./TalentDetailsComponent.vue?vue&type=template&id=6cd03a44&scoped=true"
import script from "./TalentDetailsComponent.vue?vue&type=script&lang=js"
export * from "./TalentDetailsComponent.vue?vue&type=script&lang=js"

import "./TalentDetailsComponent.vue?vue&type=style&index=0&id=6cd03a44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd03a44"]])

export default __exports__